import { render, staticRenderFns } from "./CompanySearchPopComp.vue?vue&type=template&id=36704886&scoped=true"
import script from "./CompanySearchPopComp.vue?vue&type=script&lang=js"
export * from "./CompanySearchPopComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36704886",
  null
  
)

export default component.exports